import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import EditIcon from '../../../Icons/EditMenuIcon/EditMenuIcon';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import './ModerationEdit.scss';

const ModerationEdit = ({ hash, handleOnEditClick, closeMenu }) => {
    const { getContent } = useContext(CommunityContext);
    const { isLoggedIn } = useContext(PageContext);
    const content = getContent(hash);
    const handleEditClick = useCallback(() => {
        if (!isLoggedIn()) return;
        closeMenu();
        handleOnEditClick();
        EmitMetric({
            community_content_key: `${content.type}-${hash}`,
            misc_event_count: 1,
            misc_event_type: 'edit_content_clicked',
        });
    }, [content.type, hash, isLoggedIn, handleOnEditClick, closeMenu]);
    return (
        <>
            <div
                className="component-ModerationEdit"
                onClick={handleEditClick}
                onKeyPress={handleEditClick}
                role="button"
                tabIndex={0}
            >
                <EditIcon className="moderationEdit-Icon" />
                <span className="moderationEdit-label">Edit</span>
            </div>
        </>
    );
};

ModerationEdit.propTypes = {
    hash: PropTypes.string.isRequired,
    handleOnEditClick: PropTypes.func.isRequired,
    closeMenu: PropTypes.func,
};
ModerationEdit.defaultProps = {
    closeMenu: {},
};

ModerationEdit.displayName = 'ModerationEdit';

export default ModerationEdit;
